        <!-- DeptAdd 新增机构 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="deptAdd">
      <div class="deptAdd_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>新增机构</h1>
      <div class="deptAdd_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>

    <div class="deptAdd_content clearfix fl">
      <div class="deptAdd_box fl">
        <div class="deptAdd_list clearfix">
          <span class="fl">上级机构：</span>
          <div class="fl">
            <el-cascader
              :clearable="true"
              v-model="value"
              :checkStrictly="true"
              :options="institutions"
              placeholder="系统管理机构"
              filterable
              :props="{ expandTrigger: 'hover', checkStrictly: true }"
              @change="handleChange"
            ></el-cascader>
          </div>
          <p class="fl">*必选</p>
        </div>
        <div class="deptAdd_list clearfix">
          <span class="fl">机构名称：</span>
          <div class="fl">
            <el-input v-model="form.deptName"></el-input>
          </div>
          <p class="fl">*必填</p>
        </div>
        <div class="deptAdd_list clearfix">
          <span class="fl">机构编号：</span>
          <div class="fl">
            <el-switch
              :value="true"
              active-text="由系统自动编号"
              disabled
            ></el-switch>
          </div>
        </div>
        <div class="deptAdd_list clearfix">
          <span class="fl">联系人：</span>
          <div class="fl">
            <el-input v-model="form.contactor"></el-input>
          </div>
        </div>
        <div class="deptAdd_list clearfix">
          <span class="fl">联系电话：</span>
          <div class="fl">
            <el-input v-model="form.phone"></el-input>
          </div>
        </div>
      </div>

      <div class="deptAdd_box fl">
        <div class="deptAdd_list clearfix">
          <span class="fl">地址：</span>
          <div class="fl">
            <el-input v-model="form.address"></el-input>
          </div>
        </div>
        <div class="deptAdd_list clearfix">
          <span class="fl">电子邮箱：</span>
          <div class="fl">
            <el-input v-model="form.email"></el-input>
          </div>
        </div>
        <div class="deptAdd_list clearfix">
          <span class="fl">小数点精确位数：</span>
          <div class="fl">
            <el-input v-model="form.postalcode"></el-input>
          </div>
        </div>
        <div class="deptAdd_list clearfix">
          <span class="fl">IP地址：</span>
          <div class="fl">
            <el-input v-model="form.ipAddress"></el-input>
          </div>
        </div>
        <div class="deptAdd_list clearfix">
          <span class="fl">备注：</span>
          <div class="fl">
            <el-input type="textarea" v-model="form.remark"></el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="deptAdd_btn">
      <el-button type="primary" @click="onSubmit">新增机构</el-button>
    </div>
    <div class="deptAdd_text">
      <p>1.机构层级数共分4级</p>
      <p>2.机构编号由9位数字组成，前三层各占2位，第四层占3位;</p>
      <p>3.机构编号可以由系统自动生成，也可以由用户自己填写;</p>
      <p>4.新增机构时，在选择了上级机构号后，本级机构号只填写相应位数的数字;</p>
      <p>5.编号数字规则可由用户自行定义，建议参照"全国行政区划代码"填写。</p>
    </div>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
export default {
  data() {
    return {
      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",

      // 机构树
      options: [],
      // 当前选择机构
      value: [],
      // 当前机构ID
      deptId: "",
      // 机构LIST
      form: {
        parentId: "", //上级机构ID，从弹出的机构树中选定。
        deptId: "", //自身机构ID，系统自动编号，留空不填。
        level: 1, //机构级别，1-4之间，选定上级机构时，前端脚本要自动设定该值。
        deptName: "", //机构名称
        contactor: "", //联系人
        phone: "", //联系电话
        address: "", //地址
        postalcode: "", //小数点精确位数
        email: "", //电子邮箱
        ipAddress: "", //IP地址
        remark: "", //备注
      },
      // 上级机构树list
      institutions: [],
    };
  },
  created() {
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);

    let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }

    // 获取机构树
    this.options = JSON.parse(localStorage.getItem("structure"));
    // 调用获取上级机构
    this.institutionsList(this.options);
  },
  methods: {
    // 获取上级机构
    institutionsList(options) {
      let data = options;
      let _this = this;
      for (let i = 0; i < data.length; i++) {
        (function (i) {
          if (data[i].children) {
            for (let j = 0; j < data[i].children.length; j++) {
              (function (i, j) {
                if (data[i].children[j].children) {
                  for (
                    let k = 0;
                    k < data[i].children[j].children.length;
                    k++
                  ) {
                    (function (i, j, k) {
                      if (data[i].children[j].children[k].children) {
                        data[i].children[j].children[k].children = undefined;
                      }
                    })(i, j, k);
                  }
                }
              })(i, j);
            }
          }
        })(i);
      }
      let arr = [
        {
          children: [],
          label: "新建一级机构",
          level: 0,
          parentId: "000000000",
          value: "000000000",
        },
      ];
      arr[0].children = data;
      // 设置上级机构树
      this.institutions = arr;
    },
    // 现在所属机构
    handleChange(value) {
      this.deviceId = "";
      let val = JSON.parse(JSON.stringify(value));
      if (val.length >= 1) {
        this.deptId = val[val.length - 1];
      } else {
        this.deptId = "";
      }

      this.form.parentId = this.deptId;
      this.form.level = value.length;
    },
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },
    // 新增机构
    onSubmit() {
      if (this.form.parentId !== "" && this.form.deptName !== "") {
        this.DeptMng(this.form);
      } else {
        this.$message({
          message: "必填内容不能为空！",
          type: "warning",
        });
      }
    },
    // 获取机构树
    pubAction() {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeptMng", //交易码
          option: "LIST", //交易选项
          subDept: "", //要查询的节点机构ID，返回其本身及所有下属机构，留空则默认所有机构。
          deptName: "", //机构名称，作为模糊查询条件，返回与该名称相匹配的记录。
          showType: 1, //显示方式，固定为1。
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            if (res.data.list.length > 0) {
              let list = res.data.list;

              // 机构分层
              let layer1 = [];
              let layer2 = [];
              let layer3 = [];
              let layer4 = [];

              for (let i = 0; i < list.length; i++) {
                if (list[i].level == 1) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                    children: [],
                  };
                  layer1.push(arr);
                }
                if (list[i].level == 2) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                    children: [],
                  };
                  layer2.push(arr);
                }
                if (list[i].level == 3) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                    children: [],
                  };
                  layer3.push(arr);
                }
                if (list[i].level == 4) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                  };
                  layer4.push(arr);
                }
              }

              // 合并分层 3-4
              for (let i = 0; i < layer4.length; i++) {
                for (let j = 0; j < layer3.length; j++) {
                  (function (i, j) {
                    if (layer4[i].parentId == layer3[j].value) {
                      layer3[j].children.push(layer4[i]);
                    }
                  })(i, j);
                }
              }

              for (let i = 0; i < layer3.length; i++) {
                if (layer3[i].children.length == 0) {
                  delete layer3[i].children;
                }
              }

              // 合并分层 2-3
              for (let i = 0; i < layer3.length; i++) {
                for (let j = 0; j < layer2.length; j++) {
                  (function (i, j) {
                    if (layer3[i].parentId == layer2[j].value) {
                      layer2[j].children.push(layer3[i]);
                    }
                  })(i, j);
                }
              }

              for (let i = 0; i < layer2.length; i++) {
                if (layer2[i].children.length == 0) {
                  delete layer2[i].children;
                }
              }

              // 合并分层 1-2
              for (let i = 0; i < layer2.length; i++) {
                for (let j = 0; j < layer1.length; j++) {
                  (function (i, j) {
                    if (layer2[i].parentId == layer1[j].value) {
                      layer1[j].children.push(layer2[i]);
                    }
                  })(i, j);
                }
              }

              for (let i = 0; i < layer1.length; i++) {
                if (layer1[i].children.length == 0) {
                  delete layer1[i].children;
                }
              }

              // 存储机构树
              let structure = JSON.stringify(layer1);

              this.options = JSON.parse(structure);
              localStorage.setItem("structure", structure);

              this.institutionsList(this.options);
            } else {
              localStorage.setItem("structure", "");
            }
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 新增机构
    DeptMng(from) {
      let loginToken = localStorage.getItem("loginToken");

      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeptMng", //交易码
          option: "ADD", //交易选项
          autoTick: 1, //是否由系统自动编号，固定为1。
          parentId: from.parentId, //上级机构ID，从弹出的机构树中选定。
          deptId: from.deptId, //自身机构ID，系统自动编号，留空不填。
          level: from.level, //机构级别，1-4之间，选定上级机构时，前端脚本要自动设定该值。
          deptName: from.deptName, //机构名称
          status: 1, //启用状态，填1。（固定填1，该项作为预留参数）
          contactor: from.contactor, //联系人
          phone: from.phone, //联系电话
          address: from.address, //地址
          postalcode: from.postalcode, //小数点精确位数
          email: from.email, //电子邮箱
          ipAddress: from.ipAddress, //IP地址
          remark: from.remark, //备注
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == 0) {
            this.pubAction();

            this.value = [];
            this.form.parentId = ""; //上级机构ID，从弹出的机构树中选定。
            this.form.deptId = ""; //自身机构ID，系统自动编号，留空不填。
            this.form.level = 1; //机构级别，1-4之间，选定上级机构时，前端脚本要自动设定该值。
            this.form.deptName = ""; //机构名称
            this.form.contactor = ""; //联系人
            this.form.phone = ""; //联系电话
            this.form.address = ""; //地址
            this.form.postalcode = ""; //小数点精确位数
            this.form.email = ""; //电子邮箱
            this.form.ipAddress = ""; //IP地址
            this.form.remark = ""; //备注
            this.$message({
              message: "添加成功",
              type: "success",
            });
          }else{
            
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 表头
.deptAdd {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .deptAdd_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .deptAdd_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

// 内容
.deptAdd_content {
  padding: 25px 50px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  .deptAdd_box {
    width: 40%;
    .deptAdd_list {
      margin: 20px 20px;
      line-height: 40px;
      span {
        height: 40px;
        line-height: 40px;
        text-align: right;
        width: 200px;
        margin-right: 10px;
      }
      p {
        margin-left: 10px;
        color: red;
      }
    }
  }
}
.deptAdd_btn {
  width: 100%;
  text-align: center;
  .el-button {
    width: 200px;
  }
}
.deptAdd_text {
  width: 100%;
  box-sizing: border-box;
  padding: 25px 50px;
  text-align: center;
  p {
    color: red;
    line-height: 26px;
  }
}
</style>